import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";
export const renderFastMarketIcon = (hasFastMarket, fastMarketTooltip) => {
    const props = {
        className: "rj-ev-list__ev-card-icon--tooltip",
        tooltip: fastMarketTooltip
    };
    return (hasFastMarket
        ? React.createElement(EventCardIcon, Object.assign({}, props),
            React.createElement(Icon, { i: "i-24-16 i-o-ev-fast-market" }))
        : createEmptyTooltipIcon());
};
//# sourceMappingURL=renderFastMarketIcon.js.map